import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { filter, isEmpty } from 'lodash';
// import { Header } from 'components';
import InformationIcon from 'components/common/informationIcon/InformationIcon';
// import { CellIdSheetName } from 'containers/phoenix/components/CellIdSheetName';
import {
	TextField,
	Checkbox,
	Label,
	mergeStyleSets,
} from 'office-ui-fabric-react';
import { currentTimeStamp, getDatasetTitle } from 'utils/GetDataUtil';
import {
	getDisplayCellValue,
	renderMetricsResInSheet,
} from 'containers/phoenix/utils/excelUtil';
import { metricsResFormatToExcelData } from 'containers/phoenix/utils/dataUtils';

const styles = mergeStyleSets({
	showOutputDetails: {
		padding: '16px 8px',
	},
	showOutputDetailsList: {
		padding: '0px 10px 10px 10px',
	},
});

const DisplayOutputSettingsStep = () => {
	const [reportTitleError, setReportTitleError] = useState('');
	const dispatch = useDispatch();
	const displayData = useSelector(
		state => state.data.phoenixReducers.displaySetting,
	);
	const inputData = useSelector(
		state => state.data.phoenixReducers.inputData,
	);
	const reportTitle = useSelector(
		state => state.data.phoenixReducers.displaySetting.displaySetting[0].value,
	);
	const selectedService = useSelector(state => state.data.createNewDataSet.selectedServiceData.servicename);
	const selectedDataset = useSelector(state => state.data.phoenixReducers.selectedDataset);
	const existingDataset = useSelector(state => state.data.dataSet.data);

	useEffect(() => {
		if (reportTitle === '' || selectedDataset?.duplicateClicked) {
			onTitleChange(getTitleValue());
		}
		let cellNumber = displayData?.cellId ? displayData?.cellId : getDisplayCellValue(inputData?.cellNumber);
		let sheetName = displayData?.sheetName ? displayData?.sheetName : inputData?.sheetName;
		onCellSheetChange(cellNumber, sheetName);
	}, []);

	const getTitleValue = () => {
		return getDatasetTitle(selectedDataset, selectedService, existingDataset?.reports);
	};

	const rules = {
		reportTitle: /^[^*?\\:[\]\\/]+$/,
		letterWithNumber: /^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9]+)$/,
		required: value => {
			value = value && typeof value === 'string' ? value.trim() : value;
			return !value;
		},
	};

	const onRenderLabel = props => {
		const { label, required, tooltipMessage } = props;
		return (
			<InformationIcon
				labelId={label}
				label={label}
				tooltipMessage={tooltipMessage}
				mandatory={required}
			/>
		);
	};

	const onCellSheetChange = (cellId, sheetName) => {
		dispatch({
			type: 'UPDATE_DISPLAY_CELL_SHEET',
			payload: {
				cellId,
				sheetName,
			},
		});
	};

	const onSelectChange = (event, selected) => {
		if (event.target.id === 'time-stamp') {
			dispatch({
				type: 'UPDATE_DISPLAY_SETTINGS',
				value: { id: event.target.id, value: currentTimeStamp() },
				selected: selected
			});
		} else {
			dispatch({
				type: 'UPDATE_DISPLAY_SETTINGS',
				value: { id: event.target.id },
				selected: selected
			});
		}
	};

	const getCheckboxField = item => {
		return (
			<div className="ms-Grid-row" key={item.id}>
				<div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12" dir="ltr">
					<Checkbox
						id={item.id}
						label={item.label}
						onChange={onSelectChange}
						checked={item.selected}
					/>
				</div>
			</div>
		);
	};

	const getDisplaySettings = () => {
		return (
			<>
				<div className="ms-Grid-row">
					<div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
						<Label
							className={styles.showOutputDetails}
							id="show-details"
						>
							Show Details
						</Label>
					</div>
				</div>
				<div className={styles.showOutputDetailsList}>
					{displayData.displaySetting.map(item => {
						return getCheckboxField(item);
					})}
				</div>
			</>
		);
	};

	const validateDuplicate = (existingData, newTitle, id) => {
		const { reports } = existingData;
		const existingReport = filter(reports, item => {
			if (selectedDataset && selectedDataset.reportId === item.reportId &&
				selectedDataset.reportName === item.reportName) {
				return false;
			} else {
				return item.reportName === newTitle && item.reportId !== id;
			}
		});
		return !isEmpty(existingReport);
	};

	const validateTitle = value => {
		let message = '';
		if (rules.required(value)) {
			message = 'Please provide Dataset name';
		} else if (!rules.reportTitle.test(value)) {
			message = 'Special Characters not allowed';
		} else if (validateDuplicate(existingDataset, value, null)) {
			message = 'Dataset already exists with this name, Please provide different name';
		}
		return message;
	};

	const onTitleChange = event => {
		const value = event?.target?.value ? event.target.value : (typeof event === 'object' ? '' : event);
		const error = validateTitle(value);
		if (error !== '') {
			setReportTitleError(error);
		} else {
			setReportTitleError('');
		}
		dispatch({
			type: 'UPDATE_DISPLAY_SETTINGS',
			value: { id: 'dataset-title', value: value, error: error !== '' ? true : false },
		});
	};

	return (
		<div className="ms-Grid out-put-container " dir="ltr">
			{/* <Header title='Display Settings' /> */}
			<div className="ms-Grid-row">
				<div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
					<TextField
						className="report-header"
						label="Dataset Title"
						id="report-title-phoenix-lbl"
						name="report-title"
						value={reportTitle}
						onChange={onTitleChange}
						required
						errorMessage={reportTitleError}
					/>
				</div>

				{getDisplaySettings()}

				{/* <CellIdSheetName
					cellNumber={displayData?.displayCellNumber ? displayData?.displayCellNumber : getDisplayCellValue(inputData?.cellNumber)}
					sheetName={displayData?.displaySheetName ? displayData?.displaySheetName : inputData?.sheetName}
					onRenderLabel={onRenderLabel}
					onChangeDispatch={onCellSheetChange}
				/> */}
			</div>
		</div>
	);
};

export default DisplayOutputSettingsStep;
